import React from "react";
import styles from "./CategoryPageSkeleton.module.css";
import sharedStyles from "../../../../styles/SharedLayout.module.css";

const CategoryPageSkeleton: React.FC = () => {
  return (
    <div className="container">
      <div className={sharedStyles.pageContainer}>
        <div className={styles.titleSkeleton}></div>

        {/* Category sliders skeleton */}
        <div className={styles.slidersSkeleton}>
          <div className={styles.sliderItemsSkeleton}>
            {[...Array(4)].map((_, idx) => (
              <div key={idx} className={styles.sliderItemSkeleton}></div>
            ))}
          </div>
        </div>

        <div className={sharedStyles.mainContent}>
          <div className={sharedStyles.filtersColumn}>
            {/* Filters skeleton */}
            <div className={styles.filtersSkeleton}>
              {[...Array(6)].map((_, index) => (
                <div key={index} className={styles.filterGroupSkeleton}>
                  <div className={styles.filterHeaderSkeleton}></div>
                  <div className={styles.filterOptionsSkeleton}>
                    {[...Array(4)].map((_, idx) => (
                      <div key={idx} className={styles.filterOptionSkeleton}>
                        <div className={styles.checkboxSkeleton}></div>
                        <div className={styles.labelSkeleton}></div>
                        <div className={styles.countSkeleton}></div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={sharedStyles.productsColumn}>
            {/* Sort options skeleton */}
            <div className={styles.sortSkeleton}>
              <div className={styles.sortLabelSkeleton}></div>
              <div className={styles.sortDropdownSkeleton}></div>
            </div>

            {/* Product grid skeleton */}
            <div className={styles.productGridSkeleton}>
              {[...Array(12)].map((_, index) => (
                <div key={index} className={styles.productCardSkeleton}>
                  <div className={styles.productImageSkeleton}></div>
                  <div className={styles.productContentSkeleton}>
                    <div className={styles.productPriceSkeleton}></div>
                    <div className={styles.productNameSkeleton}></div>
                    <div className={styles.productDeliverySkeleton}></div>
                    <div className={styles.productSwatchesSkeleton}>
                      {[...Array(3)].map((_, idx) => (
                        <div
                          key={idx}
                          className={styles.colorSwatchSkeleton}
                        ></div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryPageSkeleton;
